// Hooks
import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

///// Umiverse Imports
// Redux
import { setTemplateLibraryFilters } from '../../../redux/slices/umibuilder/reducers'
import { selectTemplateLibraryFilters } from '../../../redux/slices/umibuilder/selectors'
import { ClimateZones, typeDescriptors } from '../../../redux/slices/umibuilder/utils'
import { buildLUTs } from '../../../redux/utils'
// Components
import { Selector } from '../../MultiSelector'

export const TemplateFiltersConfig = {
  ClimateZone: {
    descriptor: 'Climate Zones',
    helperText: 'Select climate zone filters',
    options: ClimateZones.map((value) => ({ label: value, value })),
  },
  Type: {
    descriptor: 'Typology',
    helperText: 'Select building typology filters',
    options: typeDescriptors.map((value) => ({ label: value, value })),
  },
}

export const { enum: TemplateFilter, arr: TemplateFilters } = buildLUTs(TemplateFiltersConfig)

///// Types
type TemplateTableFilterProps = {
  parameter: keyof typeof TemplateFiltersConfig
}

///// Component
const TemplateTableFilter: React.FC<TemplateTableFilterProps> = ({ parameter }) => {
  const dispatch = useDispatch()
  const config = TemplateFiltersConfig[parameter]

  const filters = useSelector(selectTemplateLibraryFilters)
  const filterValues = useMemo(() => filters[parameter], [parameter, filters])

  const setFilterValues = useCallback(
    (values: string[]) => {
      dispatch(setTemplateLibraryFilters({ parameter, values }))
    },
    [dispatch, parameter],
  )

  return (
    <Selector
      {...config}
      name={parameter}
      activeList={filterValues}
      setActiveList={setFilterValues}
      customRender={(a: string) => a}
    />
  )
}

export default TemplateTableFilter
